import { useCallback, useEffect, useState } from "react";
import {
  COOKIE_CONSENT_ALL,
  COOKIE_CONSENT_ESSENTIAL,
  COOKIE_CONSENT_KEY,
  getCookie,
  deleteCookie,
  setCookie,
} from "../../utils/cookies";
import { Actions, Container, Header, PreferencesArea } from "./styles";
import { FaCookieBite } from "react-icons/fa";

const COOKIE_CONSENT_MAX_AGE = 60 * 60 * 24 * 365;
const OPTIONAL_COOKIE_KEYS = ["imovelList"];

export function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);
  const [isPreferencesOpen, setIsPreferencesOpen] = useState(false);
  const [allowAll, setAllowAll] = useState(true);

  useEffect(() => {
    const consentValue = getCookie(COOKIE_CONSENT_KEY);

    if (
      consentValue !== COOKIE_CONSENT_ESSENTIAL &&
      consentValue !== COOKIE_CONSENT_ALL
    ) {
      setIsVisible(true);
    }
  }, []);

  const saveConsent = useCallback((consent: string) => {
    setCookie(COOKIE_CONSENT_KEY, consent, {
      maxAge: COOKIE_CONSENT_MAX_AGE,
    });

    if (consent === COOKIE_CONSENT_ESSENTIAL) {
      OPTIONAL_COOKIE_KEYS.forEach((key) => deleteCookie(key));
    }

    setIsVisible(false);
  }, []);

  const handleAccept = useCallback(() => {
    saveConsent(allowAll ? COOKIE_CONSENT_ALL : COOKIE_CONSENT_ESSENTIAL);
  }, [allowAll, saveConsent]);

  if (!isVisible) {
    return null;
  }

  return (
    <Container role="dialog" aria-live="polite" aria-label="Aviso de cookies">
      <Header>
        <div className="icon-wrapper">
          <FaCookieBite size={24} />
        </div>
        <h3>Política de Cookies</h3>
      </Header>
      <p>
        Utilizamos cookies para melhorar sua experiência e garantir o
        funcionamento adequado do portal.{" "}
        <a
          href="/politica-de-cookies"
          target="_blank"
          rel="noopener noreferrer"
        >
          Saiba mais
        </a>
      </p>

      <Actions>
        <button
          className="button-preferences"
          type="button"
          onClick={() => setIsPreferencesOpen((prev) => !prev)}
        >
          Preferências
        </button>
        <button className="button-accept" type="button" onClick={handleAccept}>
          Aceitar
        </button>
      </Actions>

      {isPreferencesOpen && (
        <PreferencesArea>
          <div className="pref-item">
            <div className="pref-text">
              <strong>Todos os cookies</strong>
            </div>
            <label className="switch">
              <input
                type="checkbox"
                checked={allowAll}
                onChange={(e) => setAllowAll(e.target.checked)}
              />
              <span className="slider"></span>
            </label>
          </div>
          <div className="pref-item">
            <div className="pref-text">
              <strong>Apenas essenciais</strong>
            </div>
            <label className="switch">
              <input type="checkbox" checked disabled />
              <span className="slider"></span>
            </label>
          </div>
        </PreferencesArea>
      )}
    </Container>
  );
}
